import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormFields,
    FormActions,
    ValidationResult,
    CodedProperty,
    mapToDropdownOption,
    FormDropdown
} from "sprint-common-web";

import { LanguagesDataContext } from "../../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { ensureAudioFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";

export interface SoundtrackFormProps {
    isLoading: boolean;
    onCancel?(): void;
    validationResult?: ValidationResult;
    onSubmit(soundtrack?: CodedProperty): void;
}

interface SoundtrackFormInputs {
    soundtrack: string;
}

export const AudioSoundtrackForm = (props: SoundtrackFormProps): JSX.Element => {
    const { fileRecordDetails } = useFileRecordDetailsState();
    const { dubbingLanguages } = useContext(LanguagesDataContext);

    ensureAudioFileRecordDetails(fileRecordDetails);

    const defaultSoundtracks = fileRecordDetails.soundtrack ? fileRecordDetails.soundtrack.id : undefined;

    const { handleSubmit, errors, control } = useForm<SoundtrackFormInputs>({
        defaultValues: {
            soundtrack: defaultSoundtracks
        }
    });

    const closeClearedAndCallOnClose = () => {
        if (props.onCancel) {
            props.onCancel();
        }
    };

    const callOnSubmit = (formInputs: SoundtrackFormInputs) => {
        const soundtrackToSubmit = dubbingLanguages.find(
            (dubbingLanguage) => formInputs.soundtrack === dubbingLanguage.id
        );

        props.onSubmit(soundtrackToSubmit);
    };

    return (
        <Form onSubmit={handleSubmit(callOnSubmit)}>
            <FormFields>
                <FormDropdown
                    options={dubbingLanguages.map((dub) => mapToDropdownOption(dub))}
                    label="Soundtrack"
                    name="soundtrack"
                    control={control}
                    errors={errors}
                />
                <FormActions onCancel={closeClearedAndCallOnClose} isLoading={props.isLoading} />
            </FormFields>
        </Form>
    );
};
